import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconAudioMute = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      viewBox="0 0 16 16"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        d="M8.07351 2.24492C8.72009 1.68563 9.72335 2.14596 9.72335 3.00194V12.997C9.72335 13.828 8.77062 14.2965 8.11482 13.7879L3.98046 10.5816H2.49677C1.67013 10.5816 1 9.91005 1 9.08162V7.29841C1 6.46998 1.67013 5.79841 2.49677 5.79841H3.96542L8.07351 2.24492ZM8.7255 3.00194L4.3365 6.79841H2.49677C2.22122 6.79841 1.99785 7.02226 1.99785 7.29841V9.08162C1.99785 9.35776 2.22122 9.58162 2.49677 9.58162H4.32146L8.7255 12.997V3.00194Z"
        fill="currentColor"
      />
      <path
        d="M14.8763 9.67074C15.0581 9.87856 15.0371 10.1944 14.8293 10.3763C14.6214 10.5581 14.3056 10.5371 14.1237 10.3292L12.75 8.7593L11.3763 10.3293C11.1945 10.5371 10.8786 10.5581 10.6708 10.3763C10.4629 10.1945 10.4419 9.87857 10.6237 9.67075L12.0856 8L10.6237 6.32925C10.4419 6.12143 10.4629 5.80555 10.6708 5.62371C10.8786 5.44186 11.1945 5.46292 11.3763 5.67074L12.75 7.2407L14.1237 5.67075C14.3056 5.46294 14.6214 5.44188 14.8293 5.62372C15.0371 5.80556 15.0581 6.12144 14.8763 6.32926L13.4144 8L14.8763 9.67074Z"
        fill="#currentColor"
      />
    </SvgIcon>
  );
};
